// Auto-generated by splitter.py — do not regenerate; edit directly.

export const REFUND_REASONS = [
  'Event cancelled by organiser',
  'Duplicate / double payment',
  'Buyer requested refund',
  'Fraudulent transaction',
  'Ticket delivery failed',
  'Chargeback / dispute',
  'Other (specify in notes)',
];




/* ============================================================================
   EVENT INVENTORY — Operational stock, QR codes, seats, holds, credentials
   ============================================================================ */

// Treasury's exception kinds (GET /api/payouts/treasury/exceptions) — the Exceptions tab's and the dashboard's words.
// `owed` is the row as a sentence — what is waiting to be done with that money — for a place that shows one row out of
// context (the dashboard), where "Cancelled · UGX 50,000" named a kind and not the thing to do.
export const EXCEPTION_KINDS = {
  overpaid: { label: 'Overpaid', tone: 'amber', owed: (amt) => `Return ${amt} paid over an order's total` },
  voided: { label: 'Cancelled', tone: 'red', owed: (amt, r) => `Return ${amt} paid on ${r?.reason === 'expired' ? 'an expired' : 'a cancelled'} order` },
  unplaced: { label: 'Unplaced', tone: 'amber', owed: (amt) => `${amt} arrived with no order to take it` },
  refund: { label: 'Refund to send', tone: 'blue', owed: (amt) => `Send a ${amt} refund` },
};
